import { ProjectDetailsWizardStep, ProjectDetailsWizardSubStep } from "../models";

export const isStepCurrent = (step: ProjectDetailsWizardStep): boolean => {
  if (step.current) {
    return true;
  }

  return step.subSteps.some((subStep) => subStep.current);
};

export const isStepInvalid = (step: ProjectDetailsWizardStep): boolean => {
  if (step.subSteps.length > 0) {
    return !step.subSteps.every((subStep) => subStep.valid === true);
  }

  return step.valid !== true;
};

export const isSubStepCurrent = (
  subStep: ProjectDetailsWizardSubStep,
  selectedSubStep: string[] | undefined,
  parentStepKey: string
): boolean => {
  if (subStep.current) {
    return true;
  }

  return selectedSubStep?.[0] === parentStepKey && selectedSubStep?.[1] === subStep.key;
};

export const isSubStepHighlighted = (
  subStep: ProjectDetailsWizardSubStep,
  selectedSubStep: string[] | undefined,
  parentStepKey: string
): boolean => {
  return subStep.valid === true || (selectedSubStep?.[0] === parentStepKey && selectedSubStep?.[1] === subStep.key);
};

export const getCurrentStepKeys = (steps: ProjectDetailsWizardStep[]): string[] | undefined => {
  const currentStep = steps.find((step) => isStepCurrent(step));
  if (!currentStep) {
    return undefined;
  }

  const currentSubStep = currentStep.subSteps.find((subStep) => subStep.current);
  if (currentSubStep) {
    return [currentStep.key, currentSubStep.key];
  }

  return [currentStep.key];
};

export const getInitialExpandedStepKey = (steps: ProjectDetailsWizardStep[]): string | undefined => {
  const currentStepKeys = getCurrentStepKeys(steps);
  if (currentStepKeys?.length === 2) {
    return currentStepKeys[0];
  }

  return steps.find((step) => step.subSteps.length > 0)?.key;
};

export const areStepKeysEqual = (
  firstStepKeys: string[] | undefined,
  secondStepKeys: string[] | undefined
): boolean => {
  if (!firstStepKeys || !secondStepKeys) {
    return firstStepKeys === secondStepKeys;
  }

  if (firstStepKeys.length !== secondStepKeys.length) {
    return false;
  }

  return firstStepKeys.every((stepKey, stepIndex) => stepKey === secondStepKeys[stepIndex]);
};
